import { Parser } from 'json2csv'
import moment from 'moment'

export class CSVExport {

  constructor ({
    variables,
    columns = []
  }) {
    this.variables = variables
    this.columns = columns
  }

  export () {
    let data = []
    let utcOffset = moment().utcOffset() * 60 * 1000

    for (let vars of this.variables) {
      // for each variable set
      let variables = Object.keys(vars)
      for (let name of variables) {
        // for each variable
        if (this.columns.includes(name)) {
          continue
        }
        for (let [t, v] of vars[name].values) {
          // for each log entry
          let config = vars[name].config
          let base = {}
          for (let column of this.columns) {
            base[column] = vars[column]
          }
          data.push(Object.assign(base, {
            date: moment(t + utcOffset).toISOString(),
            variable: name,
            value: config[v] && config[v].code ? config[v].code : v
          }))
        }
      }
    }

    // parse to CSV
    const fields = this.columns.concat(['date', 'variable', 'value'])
    const parser = new Parser({ withBOM: true, fields })
    const csv = parser.parse(data.sort((a, b) => {
      const aDate = new Date(a.date).getTime()
      const bDate = new Date(b.date).getTime()
      return Math.sign(aDate - bDate)
    }))

    return csv
  }

}